import { ReportCustomTableColumn } from 'features/reports/typeDefs';

export const USER_GROUPS_REPORT_TITLE = 'Proof of Delivery - User Groups';
export const USER_GROUPS_REPORT_SLUG = 'user-groups-proof-of-delivery';
export const LICENSES_REPORT_TITLE = 'Proof of Delivery - Licenses';
export const LICENSES_REPORT_SLUG = 'licenses-proof-of-delivery';
export const DEFAULT_APP_SUITE = { id: '', name: '', tenantsCount: 0 };
export const DEFAULT_TENANT = { id: '', name: '', applicationSuiteId: '', isLicenseRequired: false };
export const USER_GROUP_ACLS_REPORT_TITLE = 'User Group ACLs';
export const USER_GROUP_ACLS_REPORT_SLUG = 'user-group-acls';
export const USERS_WITH_NEW_ACCESS_REPORT_TITLE = 'New Users Access';
export const USERS_WITH_NEW_ACCESS_REPORT_SLUG = 'new-users-access';
export const ACL_RESOURCE_USER_LIST_REPORT_TITLE = 'ACL Resource - User List';
export const ACL_RESOURCE_USER_LIST_REPORT_SLUG = 'acl-resource-user-list';
export const SHOW_ACTIVE_USERS_ONLY = true;
export const ACTIVE_STATUS = 'Active';
export const USERS_DEFAULT_TAKE = 1000;
export const USERS_TYPE_NAME = 'User Group Users';
export const CREATE_REPORT_CAPTION = '+ Create Report';

export const DEFAULT_USERS_COLUMNS: ReportCustomTableColumn[] = [
    { id: 'firstName', label: 'First Name', minWidth: 120, align: 'left' },
    { id: 'lastName', label: 'Last Name', minWidth: 120, align: 'left' },
    { id: 'email', label: 'Email Address', minWidth: 120, align: 'left' },
    { id: 'startDate', label: 'Start date', minWidth: 120, align: 'left' },
    { id: 'endDate', label: 'End date', minWidth: 120, align: 'left' }
];
